/**
 * B2-RIDE - OpenAPI 3.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 2.0.0
 * Contact: mobile@pikyrent.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { ConvCode } from './convCode';
import { ConvUserData } from './convUserData';

export interface ConvDataDefinitions { 
    id?: number;
    title?: string;
    description?: string;
    type?: ConvDataDefinitions.TypeEnum;
    convCodes?: Array<ConvCode>;
    convUserDatas?: Array<ConvUserData>;
}
export namespace ConvDataDefinitions {
    export type TypeEnum = 'String' | 'Photo';
    export const TypeEnum = {
        String: 'String' as TypeEnum,
        Photo: 'Photo' as TypeEnum
    };
}